/**
 * Server text still as it arrived, tags unresolved, marked so that whatever shows it knows to
 * resolve it (renderKeptText in kept-text.ts) and does so exactly once (@VOC-SERVER-002). A plain
 * string is text already resolved, or text a person typed, and is shown as it stands: scanning it
 * again for tags would turn typed characters, or a literal the server decoded, into a person's card
 * or a missing-term marker (398-f1 review 1, F1). The class is the mark, so a string can never be
 * mistaken for one.
 *
 * A module of its own, with no imports, so the API client can carry one without importing the
 * renderer and, through it, the user directory and the user-name component.
 */
export class KeptText {
  constructor(readonly text: string) {}
}
